// extracted by mini-css-extract-plugin
module.exports = {"title-container":"_6444e049b8--title-container--_JaBK","villages-list":"_6444e049b8--villages-list--fN_0n","arrow-icon":"_6444e049b8--arrow-icon--t_eFT"};